var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23231 10.7677L17.6105 2.38948M12.9063 17.3709L17.9429 3.26861C18.2119 2.5154 17.4846 1.78813 16.7314 2.05713L2.6291 7.09367C1.76117 7.40364 1.80134 8.64456 2.68751 8.89775L8.72597 10.623C9.04086 10.713 9.28701 10.9591 9.37698 11.274L11.1023 17.3125C11.3554 18.1987 12.5964 18.2388 12.9063 17.3709Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgSend;